import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useDebugMode(): boolean {
  const location = useLocation();

  return useMemo(() => {
    const queryParams = new URLSearchParams(location.search);

    return queryParams.get('debug') === 'true';
  }, [location.search]);
}
